<template>
  <div>
    <section class="">
        <div class="container">
            <figure><img src="/static/images/index/i80banner.png" class="img-responsive"></figure>
        </div>
    </section>
    <section>
            <div class="container">
                <ol class="breadcrumb hidden-xs">
                  <li><a href="/">首頁</a></li>
                  <li><a href="#">最新消息</a></li>
                  <li class="active">{{rowData.c_title}}</li>
                </ol>
                <div class="row">
                    <div class="col-sm-2">
                        <div class="aside_menu">
                            <h4 class="title">最新消息</h4>
                            <ul class="list-unstyled">
                                <li class="active item"><a href="">主要消息</a></li>
                                <li class="item"><a href="">活動消息</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-sm-10">
                        <article>
                            <h4 class="title">{{rowData.c_title}}</h4>
                            <div class="editor" v-html="rowData.c_content"></div>
                        </article>
                    </div>
                </div>
            </div>
        </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'News',
  data () {
    return {
      news: this.$store.getters.getNews,
      apiurl: this.$store.getters.getAPI,
      rowData: {}
    }
  },
  mounted: function () {
    let id = this.$route.params.id
    // console.log(this.news[0])
    this.rowData = this.news[id]
  },
  methods: {
    ...mapActions([
      'GET_NEWS'
    ])
  },
  computed: {
    ...mapGetters([
      'getNews'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// NewsDetail.vue?116c2044